import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-case-study-detail3',
  templateUrl: './case-study-detail3.component.html',
  styleUrls: ['./case-study-detail3.component.scss'],
})
export class CaseStudyDetail3Component implements OnInit {
  constructor() {}

  ngOnInit(): void {
    window.scroll(0, 0)
  }
}
